import {
  IUser,
  IUserCreateServiceProps,
  IUserHandleUpdateProps,
} from "interfaces/User";
import {
  activeUsersService,
  createUsersService,
  deleteUsersService,
  updateUsersService,
} from "../UserServices";

export async function handleUserRegisterSubmit({
  password,
  cpf,
  email,
  name,
  rg,
  role,
  mondayEntry,
  mondayExit,
  tuesdayEntry,
  tuesdayExit,
  wednesdayEntry,
  wednesdayExit,
  thursdayEntry,
  thursdayExit,
  fridayEntry,
  fridayExit,
  saturdayEntry,
  saturdayExit,
  sundayEntry,
  sundayExit,
  schedule,
}: IUserCreateServiceProps) {
  return await createUsersService({
    password,
    cpf,
    email,
    name,
    rg,
    role,
    mondayEntry,
    mondayExit,
    tuesdayEntry,
    tuesdayExit,
    wednesdayEntry,
    wednesdayExit,
    thursdayEntry,
    thursdayExit,
    fridayEntry,
    fridayExit,
    saturdayEntry,
    saturdayExit,
    sundayEntry,
    sundayExit,
    schedule,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err.response);
      return err.response;
    });
}

export async function handleUserUpdateSubmit({
  userId,
  cpf,
  email,
  name,
  rg,
  password,
  scheduleId,
  mondayEntry,
  mondayExit,
  tuesdayEntry,
  tuesdayExit,
  wednesdayEntry,
  wednesdayExit,
  thursdayEntry,
  thursdayExit,
  fridayEntry,
  fridayExit,
  saturdayEntry,
  saturdayExit,
  sundayEntry,
  sundayExit,
}: IUserHandleUpdateProps) {
  if (scheduleId)
    return await updateUsersService({
      user: { id: userId, cpf, email, name, rg },
      schedule: {
        id: scheduleId,
        mondayEntry,
        mondayExit,
        tuesdayEntry,
        tuesdayExit,
        wednesdayEntry,
        wednesdayExit,
        thursdayEntry,
        thursdayExit,
        fridayEntry,
        fridayExit,
        saturdayEntry,
        saturdayExit,
        sundayEntry,
        sundayExit,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });

  return await updateUsersService({
    user: { id: userId, password, cpf, email, name, rg },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function handleUserActiveSubmit({ user }: DeleteUserRegisterProps) {
  if (user) {
    activeUsersService(user.id)
      .then((res) => {
        localStorage.setItem("message", "Usuário ativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no user is selected");
  }
}

export function handleUserDeleteSubmit({ user }: DeleteUserRegisterProps) {
  if (user) {
    deleteUsersService(user.id)
      .then((res) => {
        localStorage.setItem("message", "Usuário desativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no user is selected");
  }
}

interface DeleteUserRegisterProps {
  user?: IUser;
}
